import React from 'react'
import { Container } from 'react-bootstrap';
import Footer from '../Footer/Footer';
import { TypeAnimation } from 'react-type-animation';
import Proyectosr from '../About/Proyectosr';


const Proyectos = () => {
  return (
<>
    <div className='separador'>
        <h3 className='colorini titulo-servicio'><TypeAnimation
        sequence={[
            "Proyectos.",500,
          ]} 
          repeat={0}
        
        style={{ fontSize: '1.5em' }}/></h3></div>
<Container fluid>
  
  <Proyectosr/>

</Container>
<div className='separador-f'>
        <Footer/>
        </div>        
  </>
  
  )
}

export default Proyectos